module.exports = __webpack_public_path__ + "static/globe-0295173772a30a1139e75f851cd18201.png";